import api from '@/modules/axios'
import apiHelperParams from '@/modules/apiHelperParams'
import apiHelperParamsJson from '@/modules/apiHelperParamsJson'

export default {
    guestUpdateInfo(params) {
        return api.post('/integration/widget20/event', apiHelperParams('update', params))
    },
    oneTimeChatSetCode(params) {
        return api.post(
            '/one-time-chat/start',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },

    sendDialogToEmail(params) {
        return api.post(
            '/integration/widget20/event',
            apiHelperParams('send-dialog-to-email', params)
        )
    },
    sendRating(params) {
        return api.post('/integration/widget20/event', apiHelperParams('rating', params))
    }
}
